/*
 * Il badge sconto di Regios sopra il prezzo.
 *
 * Perche': l'app disegna il badge da se' e lo appende in fondo al contenitore
 * delle informazioni prodotto, che col layout a 3 colonne vuol dire sotto il
 * pulsante "Aggiungi al carrello". Non c'e' un'impostazione per la posizione,
 * e la classe generica regios-dopp-generic-badge la riempie solo nei temi
 * "Other": con theme_type "hyper" il nostro segnaposto resta vuoto.
 *
 * Come: nelle impostazioni dell'app embed (Impostazioni tema > Regios
 * Discounts Embed > Badge CSS, in config/settings_data.json) il badge ha
 * "--regios-badge: 1" nel suo attributo style. Da qui lo si riconosce e lo si
 * sposta dentro <span class="product__price-badge"> stampato sopra il prezzo
 * da snippets/product-information-blocks.liquid.
 *
 * Il badge viene rifatto dall'app a ogni ricalcolo (cambio variante, sconti
 * aggiornati): un MutationObserver rimette a posto quello nuovo. Spostare un
 * nodo genera altre mutazioni, ma alla passata dopo il badge e' gia' al suo
 * posto e non si muove piu', quindi il ciclo si chiude.
 *
 * Senza badge non succede niente e il posto sopra il prezzo resta vuoto, che
 * in CSS vuol dire invisibile.
 */
(() => {
  'use strict';

  if (window.RegiosPriceBadge) return;

  const BADGE = '[style*="--regios-badge"]';
  const ANCHOR = '.product__price-badge';

  const place = () => {
    document.querySelectorAll(BADGE).forEach((badge) => {
      const scope = badge.closest('product-info') || document;
      const anchor = scope.querySelector(ANCHOR);
      if (!anchor || badge.parentElement === anchor) return;
      anchor.replaceChildren(badge);
    });
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      place();
    });
  };

  const start = () => {
    place();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };

  window.RegiosPriceBadge = { place };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
